export const MEETING_DEFAULT_LOCATION = 'Online';
